// extracted by mini-css-extract-plugin
export default {"classes":"ConfirmModalContent_classes__4adZo","noButton":"ConfirmModalContent_noButton__UbisN"};